import { Form as AntdForm, FormProps as AntdFormProps } from 'antd'
import styled from 'styled-components'
import React from 'react';

type FormProps<T = any> = AntdFormProps & {
  children?: React.ReactNode;
  customProp?: T;
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const Form = <T extends any = any>(props: FormProps<T>) => (
  <StyledForm {...props} />
)

const StyledForm = styled(AntdForm)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
